import { render, staticRenderFns } from "./Jobboard.vue?vue&type=template&id=261948a6&"
import script from "./Jobboard.vue?vue&type=script&lang=js&"
export * from "./Jobboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports